module.exports = __webpack_public_path__ + "img/kk-logo.b481a3cf.svg";